import React, { useState, useContext } from 'react'
import styled from 'styled-components'
import { ThemeContext } from 'styled-components'

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { showEditNoteModal, deleteNote, editNotes } from '../../../actions/profile'
import { ReactComponent as PinIcon } from '../../../../../images/icon-pin.svg';
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/DeleteForever";
import { ReactComponent as ArrowUp } from '../../../../../images/arrow-up.svg'
import { ReactComponent as ArrowDown } from '../../../../../images/arrow-down.svg'
import moment from 'moment'

const ButtonGroup = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  
  button {
    background: none;
    border: none;
    cursor: pointer;
    padding: 4px 8px;

    svg {
      width: 20px;
      height: 20px;
    }
  }
`

const ArrowsGroup = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`

const NotesTable = (props) => {
  const theme = useContext(ThemeContext)
  const account = props.account
  const [sortType, setSortType] = useState('created_at')
  const [sortDirection, setSortDirection] = useState(-1)

  const renderSortArrows = (isSorting, direction) => {
    return (
      <div style={{display: 'inline-block', marginLeft: '8px'}}>
        <ArrowsGroup>
          <ArrowUp fill={(isSorting && direction === 1) ? '#FFFFFF' : '#999999'} />
          <div style={{height: '3px'}}></div>
          <ArrowDown fill={(isSorting && direction === -1) ? '#FFFFFF' : '#999999'}/>
        </ArrowsGroup>
      </div>
    )
  }

  const handleSort = (type) => {
    if (type !== sortType) {
      setSortType(type)
      setSortDirection(1)
    } else {
      setSortDirection(-sortDirection)
    }
  }

  const getReverseIndex = (id) => {
    const notes = account.user.trainerNotes
    let index = 0
    for(let i = 0; i < notes.length; i++) {
      if(notes[i].id === id) {
        index = i
      }
    }
    return index
  }
  
  const togglePin = (noteId, pinned) => {
    const mods = {
      pinned: pinned
    }
    props.editNotes(props.userId, noteId, props.account.user.id, mods)
      .then(() => {
        props.setUpdateNotes(true)
      }).catch((err) => {
        console.log(err)
      });
  }
  let notes = account.user.trainerNotes.map((record, index) => { return {...record, index} })

  notes.sort((a, b) => {
    let ax = a[sortType]
    if (ax === null) {
      ax = ''
    }
    let bx = b[sortType]
    if (bx === null) {
      bx = ''
    }
    let result
    if (ax < bx) {
      result = - sortDirection
    } else if (ax > bx) {
      result = sortDirection
    } else if (a.id < b.id) {
      result = - sortDirection
    } else {
      result = sortDirection
    }
    return result
  })

  const pinnedNotes = [];
  const unpinnedNotes = [];
  notes.forEach((note, index) => {
    const date = moment.utc(note.created_at).format("MMM D, YYYY");
    const noteRender =
      <div className="custom-table-row" id="note-table-row">
        <div className="date">
          <p>{date}</p>
        </div>
        <div className="author">
          <p>{!!note.created_by ? note.created_by : "-"}</p>
        </div>
        <div className="note">
          <p>{note.note ? note.note : "-"}</p>
        </div>
        <div className="actions">
          <ButtonGroup>
            <button
              onClick={() =>
                togglePin(note.id, 1 - note.pinned)
              }
            >
              <PinIcon style={{width: '24px', height: '24px', fill: note.pinned ? theme.color.primary:'unset'}} />
            </button>
            <button
              onClick={() =>
                props.showEditNoteModal(true, getReverseIndex(note.id))
              }
            >
              <EditIcon />
            </button>
            <button
              onClick={() => {
                props.deleteNote(props.userId, note.id);
                props.setUpdateNotes(true);
              }}
            >
              <DeleteIcon />
            </button>
          </ButtonGroup>
        </div>
      </div>;
  
    if(note.pinned) {
      pinnedNotes.push(noteRender)
    } else {
      unpinnedNotes.push(noteRender)
    }
  })

  return (
    <>
      <div className="note-table">
        <div className="custom-table-header-scroll" id="note-table-header">
          <div className="date" onClick={() => handleSort('created_at')}>
            <p>Date</p>
            {renderSortArrows((sortType === 'created_at'), sortDirection)}
          </div>
          <div className="author" onClick={() => handleSort('created_by')}>
            <p>Author</p>
            {renderSortArrows((sortType === 'created_by'), sortDirection)}
          </div>
          <div className="note">
            <p>
              Note
            </p>
          </div>
          <div className="actions">
            <p>Edit</p>
          </div>
        </div>
        {pinnedNotes}
        <div className="divider"></div>
        {unpinnedNotes}
      </div>
    </>
  );
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ showEditNoteModal, deleteNote, editNotes }, dispatch)
}

export default connect(null, mapDispatchToProps)(NotesTable)
